import { Separator } from "@/components/ui/separator";
import Header from "./components/header";
import Invoices from "./components/invoices";

const InvoicesPage = () => {
  return (
    <div>
      <Header />
      <Separator className="my-5" />
      <Invoices />
    </div>
  );
};

export default InvoicesPage;
